<template>
  <div class="ma-4 px-4">
    <v-row>
      <v-col md="3" cols="10">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          hide-details="auto"
          label="Search"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col md="3" cols="2" class="d-flex justify-end">
        <v-btn
          outlined
          @click="generateDialog = true"
          style="height: 40px"
          color="primary"
        >
          <v-icon left small>mdi-auto-fix</v-icon>
          Generate Next Term Session
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="termSessions"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <!-- Start month+year combined -->
            <template #[`item.start`]="{ item }">
              {{ item.st_month }} {{ item.st_year }}
            </template>

            <!-- End month+year combined -->
            <template #[`item.end`]="{ item }">
              {{ item.end_month }} {{ item.end_year }}
            </template>

            <!-- Active chip — click to toggle -->
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ item.active ? "Active" : "Inactive" }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Generate Next dialog -->
    <v-dialog v-model="generateDialog" width="500" persistent scrollable>
      <generateNext
        v-if="generateDialog"
        @closeDialog="generateDialog = false"
        @generate="generateNextTermSessions"
      />
    </v-dialog>

    <!-- Active toggle confirm -->
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="term session"
      :name="currentItem.admission_batch_code"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import generateNext from "@/components/termSession/generateNext.vue";
import searchBar from "@/components/searchBar.vue";
import ConfirmDialog from "@/components/confirm.vue";
import { termSessionHeaders } from "@/constants/headers";

export default {
  components: {
    generateNext,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      generateDialog: false,
      currentItem: {},
      showDialog: false,
      termSessions: [],
      search: "",
      headers: termSessionHeaders,
    };
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Term Session" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.gettermSessions();
    },

    async gettermSessions() {
      await this.$axios
        .get("term_sessions")
        .then((res) => {
          this.termSessions = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },

    // Calls POST /api/term_sessions/generate_next
    async generateNextTermSessions(data) {
      await this.$axios
        .post("term_sessions/generate_next", data)
        .then((res) => {
          const count = Array.isArray(res.data.data) ? res.data.data.length : 1;
          this.$store.commit("showSnackbar", {
            message: `${count} term session(s) generated successfully`,
            color: "success",
          });
          this.generateDialog = false;
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    // Clicking the active chip calls set_active on backend
    changeConfirmation() {
      this.$axios
        .put(`term_sessions/${this.currentItem.id}/set_active_term_session`)
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: `${this.currentItem.admission_batch_code} set as active term session`,
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },

    resetValues() {
      this.generateDialog = false;
      this.showDialog = false;
      this.currentItem = {};
    },

    customFilter(value, search, item) {
      if (!search) return true;
      const activeStatus = item.active ? "Active" : "Inactive";
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>
